
import React from "react";
import { Button } from "@/components/ui/button";

interface FormActionsProps {
  onCancel: () => void;
  submitButtonText: string;
  hideCancel?: boolean;
}

const FormActions = ({ onCancel, submitButtonText, hideCancel = false }: FormActionsProps) => {
  return (
    <div className="flex gap-4 pt-4">
      {!hideCancel && (
        <Button
          type="button"
          variant="outline"
          onClick={onCancel}
        >
          Cancel
        </Button>
      )}
      <Button
        type="submit"
        className="bg-redflags-red hover:bg-redflags-red/90 text-white"
      >
        {submitButtonText}
      </Button>
    </div>
  );
};

export default FormActions;
